export default __webpack_public_path__ + "static/logo-89f6e23d5ba3817069bba201f82caa22.jpg";